import { takeEvery } from 'redux-saga/effects';
import { getQcsSyncResources, qcsSyncUpdateResource } from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';

import { getLastSyncDate } from './alertsSelectors';
import * as actions from './alertsActions';

const mkResourceConfig = (props) => mkQcsSyncResourceConfig({
  resourceName: 'alerts',
  resourceBaseUrl: '/alert/alerts',
  getLastSyncDate,
  ...props,
});

export function* getAlertsActionWatcher(): Generator<*, *, *> {
  const config = mkResourceConfig({
    successAction: actions.getAlertsSuccess,
    failureAction: actions.getAlertsFailure,
  });
  yield takeEvery(actions.getAlerts, getQcsSyncResources, config);
}

export function* updateAlertActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.updateAlertSuccess,
    failureAction: actions.updateAlertFailure,
  });
  yield takeEvery(actions.updateAlert, qcsSyncUpdateResource, config);
}

export default [
  getAlertsActionWatcher,
  updateAlertActionWatcher,
];
